import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface SectionProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}
export function Section({
  title,
  children,
  defaultOpen = true
}: SectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <div className="border-b border-slate-100 last:border-0" data-id="element-31">
      <button onClick={() => setIsOpen(!isOpen)} className="flex w-full items-center justify-between py-3 px-4 hover:bg-slate-50 transition-colors" data-id="element-32">
        <span className="text-sm font-semibold text-slate-800" data-id="element-33">{title}</span>
        {isOpen ? <ChevronUp className="w-4 h-4 text-slate-400" data-id="element-34" /> : <ChevronDown className="w-4 h-4 text-slate-400" data-id="element-35" />}
      </button>
      <AnimatePresence initial={false} data-id="element-36">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-37">
            <div className="p-4 pt-0 flex flex-col gap-4" data-id="element-38">{children}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}